<div id="sandhub-workarea">
  <div class="title-bar-area">
    <!-- class="title-area" -->
    <div>{{title}}</div>
    <!-- <div class="video-icon" (click)="openPopup()"><i class="far fa-video"></i></div> -->
    <!--<app-video-modal *ngIf="showPopup==true" [videoUrl]="videoDetail" (closeVideoPopup)="closeVideoPopup($event)"></app-video-modal>-->
    <app-video-modal *ngIf="showPopup==true" [videoType]="videoType" (closeVideoPopup)="closeVideoPopup($event)"></app-video-modal>

  </div>
</div>


<div style="height: 85vh; ">
  <app-tile-container [tiles]="tiles" [tileTemplate]="tileTemplate" (sortOrderChanged)="orderChange($event)"
                      [size]="'xlarge'" (tilePinnedChange)="addTileToast($event)" style="display: flex; justify-content: center; align-items: center; width: 100%;"></app-tile-container>
</div>

<ng-template #tileTemplate let-model="model">
  <div (click)="activateLink(model)" class="tile-content">

    <div class="tile-content-header experts-color text-wrap" title="{{model.text}}">
      {{ model.text }}
    </div>

    <div class="tile-content-image" *ngIf="!model.imageUrl.includes('RequestClientIntelligence')">
      <img [src]="model.imageUrl" alt="The model image." />
    </div>
    <div class="tile-content-image" *ngIf="model.imageUrl.includes('RequestClientIntelligence')">
      <img [src]="model.imageUrl" alt="The model image." style="height: 100px; margin: 5px;" />
    </div>

  </div>
</ng-template>
